<div class="row coreteam-item">
    <div class="col-sm-2">
    
    </div>
    <div class="col-sm-3">
        <img src="/assets/images/coreteam/godwin.png" width="250px">
    </div>
    <div class="col-sm-7">
    <h4> Godwin Robert</h4>
    A  parent, businesman and teacher by profession, Godwin  brings to Boldungu the deeper insights of learning. As an experienced mathematics and chemistry teacher at secondary level, he truely understands the pains of learners  and parents. Needless to say, he is much alive to  the endurance that parents go through to help  children with the homeworks.</div>
    </div>
